'use client';

/**
 * FormRuntimeContext — exposes the identity of the form currently being
 * rendered (form_key for builder/operational contexts, share token or slug on
 * the public /forms/{token} page) to deeply nested field components without
 * prop-drilling through DynamicSection → DynamicField.
 *
 * Used by field components that need to attribute server calls to a form —
 * e.g. OtpVerificationField sends the key to /api/v1/forms/otp so the OTP
 * email is sent via the owning client's correspondence connector.
 */

import React, { createContext, useContext } from 'react';

const FormRuntimeKeyContext = createContext<string | null>(null);

export function FormRuntimeKeyProvider({
  formKey,
  children,
}: {
  /** form_key, share token, or slug — any identifier the public API resolves */
  formKey: string | null | undefined;
  children: React.ReactNode;
}) {
  return (
    <FormRuntimeKeyContext.Provider value={formKey ?? null}>
      {children}
    </FormRuntimeKeyContext.Provider>
  );
}

export function useFormRuntimeKey(): string | null {
  return useContext(FormRuntimeKeyContext);
}
